export default __webpack_public_path__ + "static/media/Linkbrary.7abb3897.mp4";